import type { Metadata } from "next";
import Disputes from "@/Component/Admin/Disputes";

export const metadata: Metadata = {
    title: "Disputes | Connector Club",
    description: "",
};

const DisputesPage = () => {
  return (
    <Disputes />
  )
}

export default DisputesPage
